import z from "zod";

export const transportAutoEntriesCompleteSchema = z.object({
  current_equipment_usage: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  observations: z.string().optional(),
});

export type TransportAutoEntriesCompleteValidationSchema = z.infer<typeof transportAutoEntriesCompleteSchema>;
